export default "__VITE_ASSET__BAQo_PKl__"